import React from 'react';

import Header from './Header';
import {disciplines} from './constants';

const DisciplineTips1 = ({score}) => {
    const discipline = disciplines['1'];

    return (
        <div className={'ohs-discipline'}>
            <Header/>

            <div className={'ohs-discipline__content ohs-content-padding'}>
                <h2 className={'ohs-discipline__heading'}>{discipline.header}</h2>

                <p className={'ohs-discipline__score-text'}>{discipline[score]}</p>

                <h3 className={'ohs-discipline__tips-heading'}>Tips for Building a Cohesive Leadership Team:</h3>
                <p className={'ohs-discipline__tips-intro'}>
                    There are a few simple tools that serve to build a cohesive team:
                </p>

                <ol className={'ohs-discipline__tips-list'}>
                    <li>
                        <b>Use a personality instrument:</b>
                        <p>
                            Tools like <a href="https://www.workinggenius.com/" className={'ohs-discipline__link'}><i>The
                            Six Types of Working Genius</i></a> will help team members understand one another's wiring
                            and how each person can best contribute to the team. This will help team members avoid
                            making unproductive judgments about one another and instead leverage the diverse strengths
                            of the team for higher levels of morale and productivity. It will also accelerate trust by
                            speeding up the process of team members getting to know one another.
                        </p>
                    </li>
                    <li>
                        <b>Spend time together:</b>
                        <p>
                            Find opportunities to spend more time together, face-to-face. One of the biggest impediments
                            to trust building on a team is the lack of time spent working collectively. This can include
                            off- site meetings, strategic planning sessions, and even social activities. Keep in mind
                            that face time will ultimately save you time in the long run.
                        </p>
                    </li>
                    <li>
                        <b>Share personal histories:</b>
                        <p>
                            Sharing personal histories with one another will help team members understand one another’s
                            backgrounds. Just by having everyone describe relatively innocuous attributes or
                            experiences, team members will begin to relate to one another on a more personal basis and
                            see one another as human beings with life stories and interesting backgrounds. This
                            encourages greater empathy and understanding, and discourages unfair and inaccurate
                            behavioral attributions.{' '}
                            <a className={'ohs-discipline__link'}
                               href='https://www.tablegroup.com/download/personal-histories-exercise/'>Download the personal histories exercise PDF</a>.
                        </p>
                    </li>
                    <li>
                        <b>Implement the team effectiveness exercise:</b>
                        <p>
                            The team effectiveness exercise creates a simple forum for direct, constructive feedback.
                            Ask team members to identify one another’s strengths and the single most important area for
                            improvement. When done well, this allows teams to surface issues quickly and productively
                            instead of waiting months for a formal and often divisive 360-degree process. For additional
                            support in building a cohesive leadership team, read <i>The Five Dysfunctions of a
                            Team</i> and consider using the accompanying team assessment and{' '}
                            <a className={'ohs-discipline__link'}
                               href='https://www.tablegroup.com/download/team-effectiveness-exercise/'>download the team effectiveness exercise PDF</a>.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default DisciplineTips1;
